import { GroupRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createGroup: (
  fetchContext: FetchContext,
  groupRequest: GroupRequest,
  accessToken?: string,
) => Promise<number> = async (fetchContext, groupRequest, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/groups`,
  {
    method: 'POST',
    body: JSON.stringify(groupRequest),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'create group'));
